
import { useState, useEffect } from 'react';
import { BusinessLandingSettings, defaultLandingSettings } from '@/types/businessLanding';
import { getBusinessLandingSettings } from '@/utils/landingService';
import { getBusinessSettings } from '@/utils/businessService';

export const useLandingPage = (businessId?: string) => {
  const [settings, setSettings] = useState<BusinessLandingSettings>(defaultLandingSettings);
  const [businessName, setBusinessName] = useState('Our Business');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadSettings = async () => {
      setIsLoading(true);
      try {
        // First get the business settings to get the business name
        const businessSettings = await getBusinessSettings();
        if (businessSettings?.domain) {
          setBusinessName(businessSettings.domain);
        }

        // Then get the landing page settings
        const loadedSettings = await getBusinessLandingSettings(businessId || 'default-business');
        setSettings(loadedSettings);
      } catch (error) {
        console.error('Error loading landing page settings:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadSettings();
  }, [businessId]);

  return {
    settings,
    businessName,
    isLoading
  };
};
